// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__burnM","rootSmall":"AddTileButton_rootSmall__2Rp7m"};